import React from 'react';
import { Route, Switch } from 'react-router';
import { TopPage } from '../../features/top/TopPage';
import { NotFound } from '../../common/components/NotFound';
import { Charge } from '../../features/charge/Charge';
import { Ranking } from '../../features/ranking/Ranking';
import { Events } from '../../features/events/Events';
import { PrivateRoute } from './PrivateRoute';
import { LiveContainer } from '../../features/live/LiveContainer';
import { ProfilePage } from '../../features/profile/ProfilePage';
import { LiveListPage } from '../../features/live-list/LiveListPage';
import { CallbackCode } from '../../features/login/components/CallbackCode/CallbackCode';
import { useLocation } from 'react-router-dom';
import { Wallet } from '../../features/wallet/Wallet';
import { CategoryPage } from '../../features/category/CategoryPage';
import Timeline from '../../features/timeline/components/Timeline';
import { Login } from '../../features/login/Login';
import { MaintainPage } from '../../common/components/maintenance/MaintainPage';
import UserTimeLinePage from '../../features/timeline/components/UserTimeLinePage/UserTimeLinePage';

// A custom hook that builds on useLocation to parse
// the query string for you.
export const useQuery = (): URLSearchParams => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export const routes = (
  <div>
    <Switch>
      {/* Public route*/}
      <Route exact path="/" component={TopPage} />
      <Route exact path="/callback" component={CallbackCode} />

      {/* Private route that require login to show  */}
      <PrivateRoute path="/charge">
        <Charge></Charge>
      </PrivateRoute>
      <PrivateRoute path="/login">
        <Login />
      </PrivateRoute>

      <PrivateRoute exact path="/live">
        <LiveContainer.live></LiveContainer.live>
      </PrivateRoute>

      <PrivateRoute path="/live/:liveId">
        <LiveContainer.live></LiveContainer.live>
      </PrivateRoute>

      <PrivateRoute exact path="/voice">
        <LiveContainer.live></LiveContainer.live>
      </PrivateRoute>

      <PrivateRoute path="/voice/:liveId">
        <LiveContainer.live></LiveContainer.live>
      </PrivateRoute>

      <PrivateRoute path="/list/:type">
        <LiveListPage></LiveListPage>
      </PrivateRoute>

      <PrivateRoute path="/category">
        <CategoryPage></CategoryPage>
      </PrivateRoute>

      <PrivateRoute path="/live-category/:type">
        <LiveListPage></LiveListPage>
      </PrivateRoute>

      <PrivateRoute path="/ranking">
        <Ranking></Ranking>
      </PrivateRoute>

      <PrivateRoute path="/events">
        <Events></Events>
      </PrivateRoute>

      <PrivateRoute path="/profile">
        <ProfilePage />
      </PrivateRoute>
      <PrivateRoute path="/profile-user/:paramsId">
        <ProfilePage />
      </PrivateRoute>

      <PrivateRoute path="/wallet">
        <Wallet />
      </PrivateRoute>
      <PrivateRoute path="/maintenance">
        <MaintainPage />
      </PrivateRoute>

      <PrivateRoute path="/timeline/:userId">
        <UserTimeLinePage />
      </PrivateRoute>
      <PrivateRoute path="/timeline">
        <Timeline />
      </PrivateRoute>

      {/* Undefined route*/}
      <Route path="*" component={NotFound} />
    </Switch>
  </div>
);
